import React from 'react';

import PropTypes from 'prop-types';

import {
  withRouter
} from 'react-router-dom';

import {
  PackageTypes,
  PrepaidFibreUrls
} from 'src/Common/constants';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  getDrivePackageImageURL
} from 'src/Utility/utility';

import {
  DownloadSpeed,
  UploadSpeed
} from 'src/Components/Common';

import ArrowIcon from 'src/Common/SVG/ArrowIcon';

// import DiscountIcon from 'src/Common/SVG/DiscountIcon';

import './Package.css';

class Package extends React.Component {

  static contextType = SalesContext;

  state = {
    providerImage: ''
  };

  selectPackage = (props) => {

    this.context.setShowSpinner(true);

    const url = `${ PrepaidFibreUrls[window.location.hostname] }?address=${ this.context?.installationAddress?.formattedAddress }&lat=${ this.context?.installationAddress?.latitude }&lng=${ this.context?.installationAddress?.longitude }`;

    if (props.item.provider.toUpperCase().indexOf('VUMATEL REACH') !== -1) {

      this.context.setShowSpinner(false);

      window.location.replace(url);

      return;
    }

    this.context.setContractTerm(props.item.contractTerms);
    this.context.setSelectedPackage(props.item);
    window.scrollTo(0, 0);

    if (this.context.selectedAdditionalServices) {

      for (let key in this.context.selectedAdditionalServices) {

        this.context.setSelectedAdditionalServices({ key: key, value: false });
      }
    }

    console.log('Non Vumatel product');
    props.history.push('/cloud/fibre/sales/planDetails');

    this.context.setShowSpinner(false);
  };

  getHighestDiscountedAmount = (contractTerms) => {

    contractTerms = contractTerms.sort(function (a, b) {
      return parseFloat(b.discountAmount) - parseFloat(a.discountAmount) || parseInt(b.discountTerm) - parseInt(a.discountTerm);
    });

    let highestDiscountedAmount = 0;
    let correspondingTerm = null;

    for (const contractTerm of contractTerms) {
      if (contractTerm.discountAmount) {

        return {
          highestDiscountedAmount: parseFloat(contractTerm.discountAmount),
          correspondingTerm: contractTerm.discountTerm
        };
      }
    }

    return {
      highestDiscountedAmount,
      correspondingTerm
    };
  };

  componentDidMount() {

    const providerImage = getDrivePackageImageURL(this.props.item?.provider);

    this.setState({
      providerImage
    });
  }

  getColor() {

    let borderColor = 'package-wrapper ';
    let buttonColor = 'select-package-btn ';

    if (this.props.item?.isRecommended) {

      borderColor += 'package-border-recommeded';
      buttonColor += 'select-package-btn-recommended';
    } else if (this.props.item?.onDiscount || this.props.item?.onPromotion) {

      buttonColor += 'select-package-btn-discount';
    }

    return { borderColor, buttonColor };
  }

  render() {

    const { highestDiscountedAmount, correspondingTerm } = this.getHighestDiscountedAmount(this.props.item?.contractTerms);
    const discountMonthValue = correspondingTerm && correspondingTerm.split(' ');
    const discountedPrice = highestDiscountedAmount
      ? (parseInt(this.props.item.productPrice.value) - highestDiscountedAmount).toFixed(2)
      : parseInt(this.props.item.productPrice.value);

    return (

      <div
        className='package-main-container'
        onClick={() => this?.selectPackage(this?.props)}>

        <div className="package-capped-uncapped">

          { !!this.props.item?.isOnlineExclusive

            ? <section className="package-online-exclusive-banner">Online exclusive</section>
            : (!!this.props.item?.onDiscount || !!this.props.item?.onPromotion)
              ? <section className="package-promotion-banner">On promotion</section>
              : null
          }

          { this.props.item.provider?.toUpperCase().indexOf('VUMATEL REACH') !== -1

            ? <section className="package-prepaid-banner">Prepaid Fibre</section>
            : null
          }

        </div>

        <div className="package-main-wrapper">

          <div className={'package-content-wrapper'}>

            <div className="package-inclusion-section">

              <div className="download-speed-wrapper">

                <div className='speed-wrapper'>
                  <div className="and-symbol-wrapper">

                    <DownloadSpeed />
                  </div>

                  <div className="speed-value">

                    {` ${ parseInt(this.props.item.download) }Mbps`}
                  </div>
                </div>

                <div className='speed-wrapper'>
                  <div className="and-symbol-wrapper">

                    <UploadSpeed />
                  </div>

                  <div className="speed-value">

                    {` ${ parseInt(this.props.item.upload) }Mbps`}
                  </div>
                </div>
              </div>

              <div className="provider-price-wrapper">

                <div className="provider-price">

                  { this.props.item.provider?.toUpperCase().indexOf('VUMATEL REACH') !== -1 &&
                    <div className='from-text-price'>From</div>
                  }

                  {`R${ highestDiscountedAmount ? discountedPrice.split('.')[0] : this.props.item.productPrice.value.split('.')[0] }`}
                  <div className='provider-price-pm'>PM</div>

                </div>

                <div className="saved-amount">
                  { (this.props.item?.onDiscount || this.props.item?.onPromotion) &&

                    <>{`R${ parseInt(this.props.item.productPrice.value.split('.')[0]) }PM`}</>
                  }
                </div>

              </div>

              {/* <div className="discounted-price-wrapper">

                { this.props.item?.onDiscount || this.props.item?.onPromotion

                  ? <div className="discounted-price">

                      <DiscountIcon />

                      <div className="discounted-price-text">
                        {`Save for ${discountMonthValue[0]} ${discountMonthValue[0] === '1' ? 'month' : 'months'}`}
                      </div>
                    </div>

                  : null
                }
              </div> */}

              <div className="provider-logo">

                <img
                  src={getDrivePackageImageURL(this.props.item.provider)}
                  alt="provider" />

                <ArrowIcon />

              </div>

            </div>

            { this.props.item.contractTerms[0].inclusions && this.props.item.dealType !== PackageTypes.StandaloneFibreDeals

              ? <div className="package-inclusion-list">

                  <hr className="package-hr" />

                  { this.props.item.contractTerms[0].inclusions.map((inclusion, index) => {

                    return (
                      <div className="package-inclusion-item" key={index}>
                        + {inclusion}
                      </div>
                    );
                  })}

                </div>
              : null
            }

          </div>

        </div>
      </div>
    );
  }
}

Package.propTypes = {
  isPopular: PropTypes.bool,
  item: PropTypes.shape({
    contractTerms: PropTypes.arrayOf(
      PropTypes.shape({
        duration: PropTypes.string,
        inclusions: PropTypes.arrayOf(PropTypes.string),
        offerType: PropTypes.string,
        discountAmount: PropTypes.string,
        discountTerm: PropTypes.string
      })
    ),
    dataCap: PropTypes.string,
    dataType: PropTypes.string,
    dealType: PropTypes.string,
    description: PropTypes.string,
    download: PropTypes.string,
    isRecommended: PropTypes.bool,
    onDiscount: PropTypes.bool,
    onPromotion: PropTypes.bool,
    productPrice: PropTypes.shape({
      displayValue: PropTypes.string,
      unit: PropTypes.string,
      value: PropTypes.string
    }),
    provider: PropTypes.string,
    status: PropTypes.string,
    subscriptionType: PropTypes.string,
    upload: PropTypes.string
  })
};

export default withRouter(Package);